var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircuit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u56DE\u8DEF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56DE\\u8DEF\\u6570\\u636E\\u7EDF\\u8BA1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-10.000000, -72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56DE\\u8DEF",
    transform: "translate(10.500000, 74.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,7.22082499 L13.5,11.0769231 C13.5,11.5867244 13.0867244,12 12.5769231,12 L2.42307692,12 C1.91327562,12 1.5,11.5867244 1.5,11.0769231 C1.5,9.94826433 1.5,9.13042655 1.5,8.62340973 M1.5,3.56003543 C1.5,2.97404465 1.5,2.09505848 1.5,0.923076923 C1.5,0.413275616 1.91327562,0 2.42307692,0 L12.5769231,0 C13.0867244,0 13.5,0.413275616 13.5,0.923076923 L13.5,2.77363153 L13.5,4.77363153",
    id: "\\u8DEF\\u5F84-12\\u5907\\u4EFD",
    stroke: "#979797"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#979797",
    x: 12,
    y: 4,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-12",
    fill: "#979797",
    x: 12,
    y: 7,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-13",
    fill: "#F7B500",
    points: "6.59690534 2 4.7 6.62698668 6.59690534 6.62698668 5.60038333 10.7407672 9.66368047 4.85737948 7.40484739 4.85737948 9.9363445 2.0117899"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    stroke: "#979797",
    x: 0.5,
    y: 3.5,
    width: 2,
    height: 5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircuit);
export default __webpack_public_path__ + "static/media/circuit.c39f759d84a47da95c62ab985919fe65.svg";
export { ForwardRef as ReactComponent };